export default {
  bulkUpgrade: {
    modal: {
      title: "Confirm upgrade",
      description:
        "You’ve selected {count} listing{count, plural, =0 {} =1 {} other{s}} to readvertise. ",
      list: {
        label: "{count} x {label} listing{count, plural, =0 {} =1 {} other{s}}",
        credit: "{expend} Ad credits",
        listing: ", {listing} listing{listing, plural,  =0 {} =1 {} other{s}}",
      },
      summation: {
        deduction: "Total deductions",
        balance: "Balance:",
        credit: "{expend} Featured credits",
        listings: ", {expend} listings",
        discount: "{percentage}% Discount",
      },
      buttons: {
        confirm: "Confirm upgrade",
      },
      message: {
        success: "Your listing has been upgraded.",
        failed: "Your listing is not upgraded.",
      },
      upgradeType: {
        feature_prefix: "Feature ",
        promo_duration: "{duration} days",
        upgrade_to_feature_7: "7 days",
        upgrade_to_feature_28: "28 days",
      },
    },
  },
};
